import api from './api'

const URLS = {
  articles: '/articles'
}

export const getArticles = (query, config) => {
  return api.get(URLS.articles, {
    baseURL: 'http://64.225.73.88:9078',
    ...config,
    params: { ...query }
  })
}

export const deleteArticle = (id, config) => {
  return api.delete(URLS.articles + '/' + id, {
    baseURL: 'http://64.225.73.88:9078',
    ...config
  })
}
